const initialState = "kjsteachers";

const code = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_CODE':
            state = action.payload.code
            return state;

        default:
            return state;
    }
};

export default code;